import Url from '../global/Url';

async function getTypeLead() {
    try {
        const response = await fetch(Url.Crm + 'tipos-lead');
        const responseJson = await response.json();
        return responseJson.body;
    } catch (error) {
        console.error(`ERROR TIPO LEAD: ${error}`);
    }
}

export { getTypeLead };
